import {getAuditReport as getAuditReportAPI} from '../../../services/report/report'

export async function getAuditReport(data) {
  try {
    let response = await getAuditReportAPI(data)
    return response
  } catch (e) {
    console.log(`Get Audit Report: ${data}`)
  }
}
